import { useQuery } from "@tanstack/react-query";

import { getResources } from "~/api/resources";

export const useResources = () => {
  return useQuery({
    queryKey: ["resources"],
    queryFn: getResources,
  });
};
